module.exports = __webpack_public_path__ + "static/media/item_6_30_comp.48cf82a6.png";